export const GA_TRACKING_ID = "G-7DPFRJ40MG";
